<template>
  <base-message :full-width="true"
                :message="message"
                :is-active="status === 'start'"
                :fullscreen="fullscreen">
    <div class="message-body is-block">
      <div class="message-header is-vcenter">
        <label><b class="is-text-rsmall is-text-white">限时作答</b></label>
      </div>

      <div class="message-block-content">

        <div class="media is-vcenter">
          <div class="media-left">
            <count-down
                :limit="message.data.limit || 10"
                :ref="'count-down-' + _uid"
                @done="checkAnswer"
                @start.once="status = 'start'"></count-down>
          </div>
          <div class="media-content">
            <p>请快速选择正确答案，少选和选错都会扣分！<span v-if="status === 'init'">准备好开始后，请点击下方按钮</span></p>
            <div v-if="status === 'init'">
              <div class="buttons">
                <button @click="start" class="button is-small"><b>开始</b></button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="status === 'start' || status === 'done'" class="choice">
          <div v-html="problem.description" class="description"></div>

          <div
              v-for="(option, i) in options"
              :class="{'is-done': status === 'done',
                     'is-selected': teammates[0] && teammates[0].answer.includes(option[0]),
                     'is-wrong': !answer.includes(option[0]),
                     'is-answer': answer.includes(option[0])}"
              @click="select(0, option[0])"
              class="option">
            <b class="option-index">{{ String.fromCharCode(65 + i) }}</b>
            <span class="content">{{ option[1] }}</span>
            <div class="is-flex flex-pull-right">
              <img v-for="user in getOptionUsers(option)" class="head-image is-faint" :src="user" alt="">
            </div>
          </div>
        </div>
        <div v-if="status === 'done'" class="result">
          <table class="table is-striped is-bordered is-fullwidth">
            <thead>
            <tr>
              <td class="has-text-centered"></td>
              <td v-for="user in teammates" class="has-text-centered">
                <img class="head-image" :src="$imagePath(user.head_image)" alt="">
              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="has-text-centered"><b>答对</b></td>
              <td v-for="user in teammates" class="has-text-centered">{{ user.correct }}</td>
            </tr>
            <tr>
              <td class="has-text-centered"><b>答错</b></td>
              <td v-for="user in teammates" class="has-text-centered">{{ user.wrong }}</td>
            </tr>
            <tr>
              <td class="has-text-centered"><b>得分</b></td>
              <td v-for="user in teammates" class="has-text-centered">{{ user.score }}</td>
            </tr>
            <tr>
              <td class="has-text-centered"><b>用时</b></td>
              <td v-for="user in teammates" class="has-text-centered">{{ user.timeUse / 1000 | time }}秒</td>
            </tr>
            </tbody>
          </table>
          <div :class="(teammates[0] && teammates[0].wrong > 0) ? 'is-text-danger' : 'is-text-success'">
            <p v-show="teammates[0] && teammates[0].wrong > 0">啊哦，居然没有答对，请再看一遍视频吧！</p>
            <p v-show="teammates[0] && teammates[0].wrong === 0">哇，恭喜你答对了！请再接再厉！</p>
          </div>
        </div>
        <div v-if="status === 'start'"
             class="buttons"
             @click="checkAnswer(50)">
          <button class="button is-link is-small">抢先交卷</button>
        </div>

      </div>

    </div>
  </base-message>
</template>

<script>
// import LoadingDot from './LoadingDot'
import BaseMessage from './BaseMessage'
import IClassroom from '@/components/classroom/lib/IClassroom'
import CountDown from '@/components/classroom/messages/partials/CountDown'

export default {
  components: { BaseMessage, CountDown },
  props: ['message'],
  data () {
    return {
      fullscreen: false,
      startAt: 0,
      status: 'init',
      teammates: []
    }
  },
  filters: {
    time (value) {
      return value.toFixed(2)
    }
  },
  computed: {
    options () {
      if (this.problem) {
        return JSON.parse(this.problem.content)
      }
      return []
    },
    answer () {
      if (this.problem) {
        return this.problem.answer.split(',').map(a => parseInt(a))
      }
      return []
    },
    problem () {
      return IClassroom.problems.find(p => this.message.data.choice === p._id)
    }
  },
  mounted () {
    this.addTeammates(IClassroom.classmates[0], true)
    this.addTeammates(IClassroom.classmates[1])
    IClassroom.saySomething('请快速选择正确答案，你只有' + (this.message.data.limit || 10) + '秒时间完成作答')
  },
  methods: {
    start () {
      this.$refs['count-down-' + this._uid].start()
      this.startAt = Date.now()
      this.getNextTeammateCommand(this.startAt)

      setTimeout(() => {
        this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }, 100)
    },
    getNextTeammateCommand (start) {
      const now = Date.now() - this.startAt
      let wait = Infinity
      for (let i = 1; i < this.teammates.length; i++) {
        const user = this.teammates[i]
        for (let log of user.logs) {
          if (log[1] > start && log[1] <= now) {
            this.select(i, log[0])
          } else if (log[1] > now) {
            wait = Math.min(wait, log[1] - now)
            break
          }
        }
      }

      if (wait !== Infinity) {
        setTimeout(() => {
          this.getNextTeammateCommand(now)
        }, wait)
      }
    },
    addTeammates (userCommit, clear = false) {
      let logs = []
      if (!clear && userCommit.group_logs) {
        const msgLog = userCommit.group_logs.find((l) => l._id === this.message.id)

        if (msgLog && msgLog.data.actions) {
          logs = msgLog.data.actions
        }
      }
      this.teammates.push({
        head_image: userCommit.head_image,
        answer: [],
        wrong: 0,
        correct: 0,
        score: 0,
        timeUse: 0,
        logs
      })
    },
    getOptionUsers (option) {
      return this.teammates.filter(user => {
        return user.answer.includes(option[0])
      }).map(user => user.head_image).reverse()
    },
    next () {
      IClassroom.requestNextMessage(1000)
    },
    select (userIndex, option) {
      if (this.status !== 'start') return
      const user = this.teammates[userIndex]
      if (user.answer.includes(option)) {
        user.answer.splice(user.answer.indexOf(option), 1)
        userIndex === 0 && user.logs.push([option, Date.now() - this.startAt])
      } else {
        user.answer.push(option)
        userIndex === 0 && user.logs.push([option, Date.now() - this.startAt])
      }
    },
    async checkAnswer (bonus = 0) {
      this.$refs['count-down-' + this._uid].pause()
      if (this.status === 'done') {
        return
      }

      const log = IClassroom.createLog(this.message)
      log.data.actions = this.teammates[0].logs

      this.status = 'done'
      this.teammates.forEach(user => {
        user.correct = 0
        user.wrong = 0
        this.answer.forEach(a => {
          if (user.answer.includes(a)) user.correct += 1
          else user.wrong += 1
        })
        user.answer.forEach(c => {
          if (!this.answer.includes(c)) user.wrong += 1
        })

        user.score = user.correct - user.wrong
        user.timeUse = user.logs.length ? user.logs[user.logs.length - 1][1] : 0
      })

      await this.$api.put(`/student/courses/${IClassroom.course._id}/groups/${IClassroom.group._id}/problems/answers`, {
        answers: JSON.stringify([{ '_id': this.problem._id, 'answer': this.teammates[0].answer.join(',') }])
      })

      const correct = this.teammates[0].wrong === 0
      IClassroom.addScore(correct ? (10 + bonus) : 0, false)
      IClassroom.showUserBubble(0, correct ? 'check' : 'close', false, 8000)
      IClassroom.playSound(correct ? 'correct' : 'wrong')

      for (let i = 1; i < IClassroom.classmates.length; i++) {
        const user = IClassroom.classmates[i]
        let ok = true
        ok &= user.problems && user.problems[this.problem._id] && user.problems[this.problem._id].score === 10

        if (ok) {
          IClassroom.addScore(10, user.isOpponent)
        }

        IClassroom.showUserBubble(i, ok ? 'check' : 'close', false, 8000)
        await new Promise((resolve => {
          setTimeout(resolve, 30)
        }))
      }

      setTimeout(this.next, 2000)
    }
  }
}
</script>

<style lang="stylus" scoped>
.tip {
  min-height 70px
  background $link
  color white
  margin -.5em -.75em 0 -.75em
  padding .5em .75em
  padding-right 110px
  transition all .3s
}

.buttons {
  margin-top .5rem
}

.choice {
  padding .5rem 1rem
}
</style>
